import { render, staticRenderFns } from "./SetupSSH.vue?vue&type=template&id=15b7d2d3"
import script from "./SetupSSH.vue?vue&type=script&lang=js"
export * from "./SetupSSH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports